exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-footer[data-v-7272baa7] {\n  padding: 0 0 0 12px;\n  width: 60%;\n  color: rgba(6, 38, 62, 0.74);\n  font-weight: 500;\n  font-size: 0.85rem;\n  white-space: nowrap;\n  overflow-x: clip;\n  text-overflow: ellipsis;\n}\n.label-footer .details[data-v-7272baa7] {\n    display: inline-flex;\n    width: 100%;\n}\n.full-name[data-v-7272baa7]:after,\n.number[data-v-7272baa7]:after {\n  content: '\\A';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #3c7442;\n  display: inline-block;\n  margin: 0 8px;\n}\n", ""]);

// exports
